// ** React Imports
import { Fragment } from 'react'
import toast from 'react-hot-toast'
import { TFunction } from 'react-i18next'
import i18n from '@src/configs/i18n'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import moment from "moment"
const MySwal = withReactContent(Swal)

export const NotificationSuccess = (param: string) => {
  return (
    toast.success(
      <Fragment>
        <div onClick={() => toast.dismiss()} style={{ cursor: 'Pointer' }}>
          <h6 className="mb-0">{param}</h6>
        </div>
      </Fragment>
    )
  )
}
export const messageBoxError = (t: TFunction<"translation", undefined>, message: string) => {
  MySwal.fire({
    title: t('Important'),
    text: t(message),
    allowOutsideClick: false,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: t("Ok"),
    customClass: {
      cancelButton: "btn btn-danger ms-1"
    },
    buttonsStyling: false
  })
}

export const NotificationError = (param: any) => {
  let message = ''

  const extractFromErrors = (errors: any) => {
    if (Array.isArray(errors)) {
      return errors.map((e: any) => i18n.t(e.errorMessage || e)).join('\n')
    } else if (errors && typeof errors === 'object') {
      return Object.values(errors)
        .flat()
        .map((e: any) => i18n.t((e as any)?.errorMessage || e))
        .join('\n')
    }
    return ''
  }

  if (typeof param === 'string') {
    message = i18n.t(param)
  } else {
    // Prioritize response data errors (Axios error response)
    const respData = param?.response?.data
    if (respData?.errors) {
      message = extractFromErrors(respData.errors)
    } else if (typeof respData === 'string') {
      message = i18n.t(respData)
    }

    // Fallback to top-level errors (ValidationResult style)
    if (!message && param?.errors) {
      message = extractFromErrors(param.errors)
    }

    // Generic message fallbacks
    if (!message && param?.message) {
      message = i18n.t(param.message)
    }
  }

  if (!message) {
    message = i18n.t('Đã xảy ra lỗi. Vui lòng thử lại sau.')
  }

  return toast.error(
    <Fragment>
      <div onClick={() => toast.dismiss()} style={{ cursor: 'pointer' }}>
        <p className='mb-0' style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem', fontWeight: 500 }}>{message}</p>
      </div>
    </Fragment>,
    {
      duration: 5000
    }
  )
}

export const messageBoxConfirmDelete = (t: TFunction<"translation", undefined>, handle: any, data: any) => {
  MySwal.fire({
    title: t('Confirm'),
    text: t('Do you want to delete item?'),
    allowOutsideClick: false,
    showCancelButton: true,
    confirmButtonText: t('Delete'),
    cancelButtonText: t("Cancel"),
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1"
    },
    buttonsStyling: false
  }).then(async (result) => {
    if (result.value) {
      handle(data)
    }
  })
}

export const messageBoxConfirmApprove = (t: TFunction<"translation", undefined>, handle: any, data: any) => {
  MySwal.fire({
    title: t('Confirm'),
    text: t('Do you want to approve item?'),
    allowOutsideClick: false,
    showCancelButton: true,
    confirmButtonText: t('Approve'),
    cancelButtonText: t("Cancel"),
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1"
    },
    buttonsStyling: false
  }).then(async (result) => {
    if (result.value) {
      handle(data)
    }
  })
}

export const messageBoxWorkFlow = (info: any) => {
  MySwal.fire({
    title: '',
    text: info.comment,
    html: `
      <div style="text-align: left;">
        <p>Người xử lý: ${info.updatedByName}</p>
        <p>Thời gian: ${moment(new Date(info.updatedDate)).format('DD/MM/yyyy HH:mm')} </p>
        <p>Ý kiến: ${info.comment}</p>
      </div>
    `,
    allowOutsideClick: false,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: "Đóng",
    customClass: {
      cancelButton: "btn btn-danger ms-1"
    },
    buttonsStyling: false
  })
}

let isAuthConflictDialogVisible = false

export const showLoggedOutElsewhereDialog = () => {
  if (isAuthConflictDialogVisible) {
    return
  }

  isAuthConflictDialogVisible = true

  MySwal.fire({
    title: 'Phiên đăng nhập đã kết thúc',
    text: 'Tài khoản của bạn đã được đăng nhập ở thiết bị khác. Vui lòng đăng nhập lại để tiếp tục.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Đăng nhập lại',
    cancelButtonText: 'Về trang chủ',
    allowOutsideClick: false,
    focusConfirm: false,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-secondary ms-1'
    },
    buttonsStyling: false
  }).then(result => {
    isAuthConflictDialogVisible = false

    if (result.isConfirmed) {
      const currentUrl = typeof window !== 'undefined' ? window.location.href : ''
      window.location.href = currentUrl ? `/login?returnUrl=${encodeURIComponent(currentUrl)}` : '/login'
      return
    }

    window.location.href = '/'
  })
}